import { Module } from "wrapper6";
import { objectFit } from "../utils/_object-fit";
import PostSlider from "../utils/_post-slider";
import VideoSliderClass from "../utils/_video-slider";

var $ = jQuery;

export default class Search extends Module {
	ready(app) {
        $('#region-select').change(function(e){
            Search.regionSelect($(this));
        });
        $('#search-form').submit(function(e){
            Search.submitForm(e, $(this));

        });

        this.countrySelect();
    }

    static regionSelect(elem){
        $('#country-select').parent().addClass('loading');
        // Get Region countries
        $.post( ajaxurl, {
            action: 'get_countries_of_region',
            region: elem.val()
        }).done( function(countries) {
            $('#country-select').html('<option value="" selected>Alle lande</option>');
            for(let key in countries){
                const country = countries[key];
                const title = country.name;
                $('#country-select').append('<option data-flag="'+country.flag+'" value="'+country.term_id+'">'+title+'</option>');
            }
            $('#country-select').parent().removeClass('loading');
            Search.hideFlag();
        });
    }

    static submitForm(event, form){
        event.preventDefault();

        // send form to server
        let data = new FormData(event.currentTarget);
        data.append('action', 'main_search_form_post')

        Search.showLoader();
        Search.hidePagination();


        jQuery.ajax({
            url: ajaxurl,
            data: data,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function(data){

                Search.hideMenuItems(data.types);
        
                // paste markup
                $('#search-dist').html(data.markup);

                // run after
                objectFit();

                // Initialize new sliders
                const SEARCH_WRAPPERS = document.querySelectorAll('.mtt-search-slider');
                if (SEARCH_WRAPPERS.length) {
                    for (let i = 0; i < SEARCH_WRAPPERS.length; i++) {
                        new PostSlider(SEARCH_WRAPPERS[i], '');
                    }
                }

                // Initialize new video slider
                new VideoSliderClass();

                Search.removeLoader();

                // Scroll to results
                Search.scrollToResults();
            }
        });
    }
    static hidePagination(){
        Search.togglePagination(false);
    }
    static showPagination(){
        Search.togglePagination(true);
    }
    static togglePagination($bool){
	    jQuery('#pagination').toggle($bool);
    }

    countrySelect() {
        $('#country-select').change(function(e) {
            const SELECTED = $(this).find('option:selected').attr('data-flag');

            if(SELECTED !== undefined && SELECTED !== "null") {
                Search.showFlag( SELECTED )
            } else {
                Search.hideFlag();
            }
        });
    }

    static showFlag(src) {
        if(src === ''){
            Search.hideFlag();
        }else {
            $('#country-select-flag img')
                .attr('src', src)
                .show();
            $('#country-select').parent().addClass('mtt-search-cover__input--show-flag');
        }
    }

    static hideFlag() {
        $('#country-select-flag img').hide();
        $('#country-select').parent().removeClass('mtt-search-cover__input--show-flag');
    }

    static showLoader() {
        $('.mtt-search-cover__submit button').addClass('loading');
        $('#search-dist').addClass('mtt-search-page-wrap--loading');
        $('.mtt-search-page-wrap__loader').addClass('mtt-search-page-wrap__loader--show');
    }

    static removeLoader() {
        $('.mtt-search-cover__submit button').removeClass('loading');
        $('#search-dist').removeClass('mtt-search-page-wrap--loading');
        $('.mtt-search-page-wrap__loader').removeClass('mtt-search-page-wrap__loader--show');
    }

    static scrollToResults() {
        if ($('#search-dist').length > 0) {

            let offset = 0;

            if ($('#main_header').length > 0) {
                offset += $('#main_header').outerHeight();
            }

            $('html, body').animate({
                scrollTop: $('#search-dist').offset().top - offset
            }, 1000);
        }
    }

    static hideMenuItems(types) {
        const MENU_ITEMS = document.querySelectorAll('.current-menu-item .sub-menu a');
        if (MENU_ITEMS.length && typeof types === 'object') {
            for (let i = 0; i < MENU_ITEMS.length; i++) {

                const MENU_ITEM = MENU_ITEMS[i];
                let menu_item_id = MENU_ITEM.getAttribute('href');
                menu_item_id = menu_item_id.replace('#mtt-search-', '');

                // show menu item if type section exists
                if (types.indexOf(menu_item_id) !== -1) {
                    MENU_ITEM.parentElement.style.display = 'block';
                } else {
                    MENU_ITEM.parentElement.style.display = 'none';
                }
            }
        }
    }
}